/**
 * 路由配置文件
 * 懒加载: const Foo = () => import('./Foo.vue')
 * 嵌套路由：https://router.vuejs.org/zh/guide/essentials/nested-routes.html
 * 编程式导航：https://router.vuejs.org/zh/guide/essentials/navigation.html
 * 路由元信息：https://router.vuejs.org/zh/guide/advanced/meta.html
 */

import Vue from 'vue'
import Router from 'vue-router'

const Sliders = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Sliders')

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Sliders', component: Sliders }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js